export default {"src":"/oferta/_next/static/media/training.a73aae8f.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};